module.exports = __webpack_public_path__ + "static/media/Expertise_FAKE.510bcdfc.png";